<nb-card accent="success">
  <nb-card-header>
    <div class="row">
      <div class="col-auto mr-auto" style="max-width: 80%">
        <div>{{ tableName }}</div>
        <div *ngIf="description">{{ description }}</div>
      </div>
      <div class="col-auto">
        <button
          nbButton
          *ngIf="dataType === 'insight' && failedInsights && failedInsights.length > 0"
          status="info"
          size="small"
          shape="round"
          (click)="clicked({ action: 'failed_insights' })"
          style="margin-right: 8px"
          i18n
        >
          You have {{ failedInsights.length }} failed insights
        </button>
        <button
          nbButton
          outline
          status="info"
          shape="round"
          size="small"
          (click)="editTableColumns()"
          nbTooltip="Edit Columns"
          i18n-nbTooltip
          style="margin-right: 8px"
          [disabled]="dataSource.data.length === 0"
        >
          <nb-icon icon="settings-outline"></nb-icon>
        </button>
        <button
          nbButton
          outline
          status="info"
          shape="round"
          size="small"
          (click)="clicked({ action: 'refresh' })"
          nbTooltip="Refresh Table"
          i18n-nbTooltip
        >
          <nb-icon icon="refresh-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="d-flex align-items-center mb-3">
      <button
        nbButton
        *ngIf="displayedActions['create']"
        status="success"
        size="small"
        shape="round"
        (click)="clicked({ action: 'create' })"
      >
        {{ getCreateButtonTitle() }}
      </button>
      <div
        *ngIf="dataType === 'my_campaign' || dataType === 'campaign'"
        class="ml-auto d-inline-flex"
        nbTooltip="Filter Campaigns"
        i18n-nbTooltip
      >
        <button nbButton [nbPopover]="filterCampaignsTemplate" nbPopoverTrigger="click" nbPopoverPlacement="bottom">
          <nb-icon icon="funnel-outline"></nb-icon>
        </button>
      </div>
      <ng-template #filterCampaignsTemplate>
        <div class="p-3" style="min-width: 310px">
          <div class="d-flex mb-2">
            <div style="font-weight: 600" i18n>Filter Campaigns</div>
            <button nbButton size="tiny" status="basic" class="ml-auto" (click)="clearCampaignTypeSelections()">
              <span i18n>Clear</span>
            </button>
          </div>
          <div class="mb-3">
            <input
              nbInput
              fullWidth
              fieldSize="small"
              type="text"
              placeholder="Search..."
              i18n-placeholder
              [value]="campaignTypeSearch"
              (input)="onCampaignTypeSearch($any($event.target).value)"
            />
          </div>
          <div style="max-height: 310px; overflow: auto">
            <label class="d-block text-muted mb-2" style="font-weight: 600; font-size: 0.9rem" i18n>
              Execution Type
            </label>
            <nb-checkbox
              class="d-block mb-2"
              [checked]="executionTypes.has('batch')"
              (checkedChange)="onExecutionTypeChange('batch', $event)"
            >
              <span i18n>Batch</span>
            </nb-checkbox>
            <nb-checkbox
              class="d-block mb-3"
              [checked]="executionTypes.has('realtime')"
              (checkedChange)="onExecutionTypeChange('realtime', $event)"
            >
              <span i18n>Real Time</span>
            </nb-checkbox>
            <label class="d-block text-muted" style="font-weight: 600; font-size: 0.9rem" i18n>Campaign Type</label>
            <nb-checkbox
              *ngFor="let campaignType of filteredCampaignTypes"
              class="d-block mt-2"
              [checked]="selectedCampaignTypes.has(campaignType.value)"
              (checkedChange)="onCampaignTypeCheckedChange(campaignType.value, $event)"
            >
              {{ campaignType.name }}
            </nb-checkbox>
          </div>
        </div>
      </ng-template>
    </div>

    <div *ngIf="dataType === 'my_campaign' || dataType === 'campaign'" class="filter-badges">
      <button
        *ngFor="let value of selectedCampaignTypesArray"
        size="tiny"
        class="badge badge-blue"
        (click)="removeCampaignTypeFilter(value)"
      >
        {{ getCampaignTypeName(value) }}
        <nb-icon icon="close-outline" class="ml-1"></nb-icon>
      </button>
    </div>

    <div class="table-scroll">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        [matSortActive]="sortActive"
        [matSortDirection]="sortDirection"
        multiTemplateDataRows
        cdkDropList
        cdkDropListLockAxis="x"
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)"
        [trackBy]="trackById"
      >
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef cdkDrag i18n>ACTIONS</th>
          <td mat-cell *matCellDef="let row">
            <div style="white-space: nowrap">
              <button
                nbButton
                ghost
                status="success"
                class="action-button"
                (click)="clicked({ action: 'view', data: row })"
                nbTooltip="View Details"
                i18n-nbTooltip
              >
                <nb-icon icon="search-outline"></nb-icon>
              </button>
              <button
                nbButton
                ghost
                status="warning"
                class="action-button"
                *ngIf="displayedActions['edit']"
                (click)="clicked({ action: 'edit', data: row })"
                nbTooltip="Edit"
                i18n-nbTooltip
              >
                <nb-icon icon="edit-outline"></nb-icon>
              </button>
              <button
                nbButton
                ghost
                status="success"
                class="action-button"
                *ngIf="displayedActions['stats']"
                (click)="clicked({ action: 'stats', data: row })"
                nbTooltip="View Statistics"
                i18n-nbTooltip
              >
                <nb-icon icon="pie-chart-outline"></nb-icon>
              </button>
              <button
                nbButton
                ghost
                status="success"
                class="action-button"
                *ngIf="displayedActions['start']"
                (click)="clicked({ action: 'start', data: row })"
                nbTooltip="Start Job"
                i18n-nbTooltip
              >
                <nb-icon icon="play-circle-outline"></nb-icon>
              </button>
              <button
                nbButton
                ghost
                status="success"
                class="action-button"
                *ngIf="displayedActions['stop']"
                (click)="clicked({ action: 'stop', data: row })"
                nbTooltip="Stop Job"
                i18n-nbTooltip
              >
                <nb-icon icon="stop-circle-outline"></nb-icon>
              </button>
              <button
                nbButton
                ghost
                status="warning"
                class="action-button"
                *ngIf="displayedActions['clone']"
                (click)="clicked({ action: 'clone', data: row })"
                nbTooltip="Clone"
                i18n-nbTooltip
              >
                <nb-icon icon="copy-outline"></nb-icon>
              </button>
              <button
                nbButton
                ghost
                status="danger"
                class="action-button"
                *ngIf="displayedActions['delete']"
                (click)="clicked({ action: 'delete', data: row })"
                nbTooltip="Delete"
                i18n-nbTooltip
              >
                <nb-icon icon="trash-2-outline"></nb-icon>
              </button>
              <button
                nbButton
                ghost
                status="warning"
                class="action-button"
                *ngIf="displayedActions['favorite']"
                (click)="toggleFavorite(row)"
                nbTooltip="Favorite"
                i18n-nbTooltip
              >
                <nb-icon [icon]="isFavorite(row)"></nb-icon>
              </button>
            </div>
          </td>
        </ng-container>
        <ng-container *ngFor="let column of displayedColumns" matColumnDef="{{ column }}">
          <th mat-header-cell *matHeaderCellDef cdkDrag>
            <div mat-sort-header>
              {{ column | replaceunderscore | uppercase }}
            </div>
            <div>
              <input
                nbInput
                fullWidth
                type="text"
                fieldSize="small"
                placeholder="Search..."
                i18n-placeholder
                (keyup)="applyFilter($event, column)"
                class="filter"
              />
            </div>
          </th>
          <td mat-cell *matCellDef="let row">
            <div [ngSwitch]="column">
              <div *ngSwitchCase="'status'">
                <app-status-light [value]="row[column]"></app-status-light>
              </div>
              <div *ngSwitchCase="'metadata'">
                <app-metadata-table-cell [tableData]="row[column]"></app-metadata-table-cell>
              </div>
              <div *ngSwitchCase="'payload_records'">
                <app-more-details-cell [value]="row[column]"></app-more-details-cell>
              </div>
              <div *ngSwitchDefault>
                {{ row[column] | customValueHandling: column }}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef cdkDrag></th>
          <td mat-cell *matCellDef="let row" style="width: 60px">
            <button
              nbButton
              ghost
              size="small"
              (click)="expand(row); $event.stopPropagation()"
              class="toggle-button"
              [class.toggle-button-expanded]="isExpanded(row)"
              nbTooltip="Expand Row"
              i18n-nbTooltip
            >
              <nb-icon icon="arrow-ios-downward-outline" style="transform: scale(1.5)"></nb-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="details">
          <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length + 1">
            <div class="element-detail-wrapper" [class.element-detail-wrapper-expanded]="isExpanded(row)">
              <div class="element-detail d-flex justify-content-center">
                <nb-card class="m-3">
                  <nb-card-header>
                    <div class="d-flex">
                      <div class="flex-grow-1 d-flex align-items-center text-nowrap">
                        <div>Campaign</div>
                      </div>
                      <button
                        nbButton
                        outline
                        shape="round"
                        size="small"
                        status="info"
                        class="ml-5"
                        (click)="clicked({ action: 'view', data: row, dataType: 'campaign' })"
                        nbTooltip="View Details"
                        i18n-nbTooltip
                      >
                        <nb-icon icon="search-outline"></nb-icon>
                      </button>
                      <button
                        nbButton
                        outline
                        shape="round"
                        size="small"
                        status="info"
                        class="ml-2"
                        (click)="clicked({ action: 'stats', data: row, dataType: 'campaign' })"
                        nbTooltip="View Statistics"
                        i18n-nbTooltip
                      >
                        <nb-icon icon="pie-chart-outline"></nb-icon>
                      </button>
                    </div>
                  </nb-card-header>
                  <nb-card-body class="d-flex overflow-hidden">
                    <div>
                      <div style="font-weight: 600" i18n>Last Ran At:</div>
                      <div *ngIf="row.last_run_time" class="mb-2">
                        {{ row.last_run_time | customValueHandling: 'last_run_time' }}
                      </div>
                      <div *ngIf="!row.last_run_time" class="mb-2" i18n>Awaiting Initial Run</div>
                    </div>
                    <div class="ml-5">
                      <div style="font-weight: 600" i18n>Total Deliveries:</div>
                      <div *ngIf="row.last_run_time">
                        {{ row.total_results | customValueHandling: 'total_results' }}
                      </div>
                      <div *ngIf="!row.last_run_time" class="mb-2" i18n>N/A</div>
                    </div>
                  </nb-card-body>
                </nb-card>
                <nb-card class="m-3" *ngIf="row.insight">
                  <nb-card-header>
                    <div class="d-flex">
                      <div class="flex-grow-1 d-flex align-items-center text-nowrap">
                        <div>Insight</div>
                      </div>
                      <button
                        nbButton
                        outline
                        shape="round"
                        size="small"
                        status="info"
                        class="ml-5"
                        (click)="clicked({ action: 'view', data: row.insight, dataType: 'insight' })"
                        nbTooltip="View Details"
                        i18n-nbTooltip
                      >
                        <nb-icon icon="search-outline"></nb-icon>
                      </button>
                      <button
                        nbButton
                        outline
                        shape="round"
                        size="small"
                        status="info"
                        class="ml-2"
                        (click)="clicked({ action: 'stats', data: row.insight, dataType: 'insight' })"
                        nbTooltip="View Statistics"
                        i18n-nbTooltip
                      >
                        <nb-icon icon="pie-chart-outline"></nb-icon>
                      </button>
                    </div>
                  </nb-card-header>
                  <nb-card-body class="d-flex overflow-hidden">
                    <div>
                      <div style="font-weight: 600" i18n>Last Ran At:</div>
                      <div *ngIf="row.insight.last_run_time" class="mb-2">
                        {{ row.insight.last_run_time | customValueHandling: 'last_run_time' }}
                      </div>
                      <div *ngIf="!row.insight.last_run_time" class="mb-2" i18n>Awaiting initial run</div>
                    </div>
                    <div class="ml-5">
                      <div style="font-weight: 600" i18n>Total Results:</div>
                      <div *ngIf="row.insight.last_run_time">
                        {{ row.insight.total_results | customValueHandling: 'total_results' }}
                      </div>
                      <div *ngIf="!row.insight.last_run_time" class="mb-2" i18n>N/A</div>
                    </div>
                  </nb-card-body>
                </nb-card>
              </div>
            </div>
          </td>
        </ng-container>
        <div *ngIf="dataType !== 'my_campaign'">
          <tr mat-header-row *matHeaderRowDef="['actions'].concat(displayedColumns)"></tr>
          <tr mat-header-row *matHeaderRowDef="['progressBar']; sticky: true" class="progress-bar-row"></tr>
          <tr mat-row *matRowDef="let row; columns: ['actions'].concat(displayedColumns)"></tr>
        </div>
        <div *ngIf="dataType === 'my_campaign'">
          <tr mat-header-row *matHeaderRowDef="displayedColumns.concat('expand')"></tr>
          <tr mat-header-row *matHeaderRowDef="['progressBar']; sticky: true" class="progress-bar-row"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns.concat('expand')"
            class="element-row"
            [class.expanded-row]="isExpanded(row)"
            (click)="expand(row)"
          ></tr>
          <tr mat-row *matRowDef="let element; columns: ['details']" class="detail-row"></tr>
        </div>
        <ng-container>
          <tr class="mat-mdc-row no-data-row" *matNoDataRow>
            <td *ngIf="_tableData && _tableData.length === 0" class="mat-mdc-cell" colspan="100%" i18n>
              No data found
            </td>
            <td *ngIf="_tableData && _tableData.length > 0" class="mat-mdc-cell" colspan="100%" i18n>
              No data matches the column filters
            </td>
          </tr>
        </ng-container>
        <ng-container matColumnDef="progressBar">
          <th mat-header-cell *matHeaderCellDef colspan="100%" class="progress-bar-cell">
            <mat-progress-bar *ngIf="!_tableData" mode="indeterminate"></mat-progress-bar>
          </th>
        </ng-container>
      </table>
    </div>
  </nb-card-body>
  <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</nb-card>
